import { Injectable } from '@angular/core';
import { NgbOffcanvas, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({ providedIn: 'root' })
export class OffcanvasHistoryService {
    private stack: NgbOffcanvasRef[] = [];

    constructor(private offcanvasService: NgbOffcanvas) {
        window.addEventListener('popstate', this.onPopState.bind(this));
    }

    open(content: any, options?: any): NgbOffcanvasRef {

        history.pushState(null, '', location.href);

        const ref = this.offcanvasService.open(content, options);
        this.stack.push(ref);

        ref.hidden.subscribe(() => {
            this.removeFromStack(ref);
        });

        return ref;
    }

    private onPopState() {
        if (this.stack.length > 0) {
            const last = this.stack.pop();
            last?.close();
        }
    }

    dismiss(result?: any) {
        if (this.stack.length > 0) {
            if (result) {
                const last = this.stack.pop();
                last?.close(result);
            } else {
                history.back();
            }
        }
    }

    private removeFromStack(ref: NgbOffcanvasRef) {
        const index = this.stack.indexOf(ref);
        if (index !== -1) this.stack.splice(index, 1);
    }
}
